// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3kpmi","title":"Images90_title__35gFq","images":"Images90_images__3m5zY"};